/**
 * "Open in Season vs last year" from a cell of another dashboard (CU-869fmjzrh D16, UX T5): Season's own URL (its
 * `viewState.parseView`), with the office, the length, the cell's pick-ups as fixed dates, the statistic, the cars and
 * the market filter. Season captures "up to yesterday" with its own window; the caller's toast says so.
 * Pure and alias-free.
 */
import { CARS } from './cars.js'
import { toIso, fromIso } from './dates.js'

// Day before · Week before · Year before (same weekday) · Year before, same date → Season's Compare with
export const SEASON_CMP = Object.freeze({ day: ['yday', null], week: ['lw', null], year: ['ly', '0'], yearSame: ['ly', '1'] })

const asIso = d => (d instanceof Date ? toIso(d) : toIso(fromIso(d)))

export function seasonParams({ office, lor, from, to, cmp = 'day', by = 'day', stat = 'min', cars = CARS.ALL, carsIds = [], tier = null, providers = [] }) {
	const p = new URLSearchParams()
	p.set('office', String(office))
	p.set('lor', String(lor))
	p.set('range', 'fixed')
	p.set('from', asIso(from))
	p.set('to', asIso(to))
	const [c, same] = SEASON_CMP[cmp] || SEASON_CMP.day
	p.set('cmp', c)
	if (same !== null) p.set('same', same)
	p.set('by', by === 'day' ? 'day' : 'week')
	p.set('stat', stat)
	p.set('prev', '0')
	if (cars !== CARS.ALL && carsIds?.length) {
		p.set('cars', cars)
		p.set('carsIds', carsIds.join(','))
	}
	if (tier) p.set('tier', String(tier))
	else if (providers?.length) p.set('providers', providers.join(','))
	return p.toString()
}

export const seasonUrl = (path, args) => `${path}?${seasonParams(args)}`
